import {useJsonFetch} from '@sail/data';
import type {FetchState} from '@sail/data';

import {getCryptoStandaloneUrl} from 'src/utils/buildStripeApiClient';
import {SessionContext} from 'src/state/usePayinSessionContext';

export const useResumePayinSession = (): FetchState<
  SessionContext | {error: string}
> => {
  const slug = new URL(window.location.toString()).pathname.split('/')[2];
  const mode = new URL(window.location.toString()).pathname.split('/')[1];

  return useJsonFetch<SessionContext | {error: string}>(
    getCryptoStandaloneUrl('/resume_payin_session'),
    {
      method: 'POST',
      body: new URLSearchParams({
        session_hash: slug,
        referrer: window.location.hostname,
        mode,
      }).toString(),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest',
      },
    },
  );
};
